export const SideBarConstants = {
    ON_CHANGE_MENUKEY: 'ON_CHANGE_MENUKEY',
    ON_CHANGE_THEME: 'ON_CHANGE_THEME',
    ON_RESET: 'ON_RESET',
};